module.exports = __webpack_public_path__ + "static/media/package-5.8aff9b74.jpg";